import { render, staticRenderFns } from "./doc-list.vue?vue&type=template&id=893936e0&scoped=true"
import script from "./doc-list.vue?vue&type=script&lang=js"
export * from "./doc-list.vue?vue&type=script&lang=js"
import style0 from "./doc-list.vue?vue&type=style&index=0&id=893936e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893936e0",
  null
  
)

export default component.exports